import { defineStore } from "pinia"

const getCompanyId = company => company?.companyId ?? company?.id ?? null

export const useBusinessStore = defineStore("business", () => {
  const companies = ref([])
  const selectedCompanyId = ref(null)
  const selectedUnitId = ref(null)
  const loading = ref(false)
  const initialized = ref(false)
  const error = ref(null)

  const selectedCompany = computed(() => companies.value.find(
    company => String(getCompanyId(company)) === String(selectedCompanyId.value),
  ) || null)

  const setCompany = companyId => {
    selectedCompanyId.value = companyId || null
    selectedUnitId.value = null
    if (import.meta.client) useCookie("businessCompanyId").value = selectedCompanyId.value
  }

  const setUnit = unitId => {
    selectedUnitId.value = unitId || null
  }

  const loadCompanies = async ({ force = false } = {}) => {
    if ((initialized.value && !force) || loading.value) return companies.value

    loading.value = true
    error.value = null
    try {
      const { allCompaniesForEdit } = useRequest()
      const response = await allCompaniesForEdit({ globalLoading: false })
      if (response?.error?.value) throw response.error.value

      companies.value = Array.isArray(response?.data?.value) ? response.data.value : []
      const rememberedId = useCookie("businessCompanyId").value
      const rememberedExists = companies.value.some(
        company => String(getCompanyId(company)) === String(rememberedId),
      )
      const fallbackId = getCompanyId(companies.value[0])
      setCompany(rememberedExists ? rememberedId : fallbackId)
      initialized.value = true
    }
    catch (requestError) {
      error.value = requestError
    }
    finally {
      loading.value = false
    }

    return companies.value
  }

  const reset = () => {
    companies.value = []
    selectedCompanyId.value = null
    selectedUnitId.value = null
    initialized.value = false
    error.value = null
  }

  return {
    companies,
    selectedCompanyId,
    selectedCompany,
    selectedUnitId,
    loading,
    initialized,
    error,
    setCompany,
    setUnit,
    loadCompanies,
    reset,
  }
})
